import React, { Component, Fragment } from 'react';
import {
    CANNOT_SELECT_IMG_MSG,
    EMPTY_ARRAY_MSG, 
    NOT_NEWS_MSG,
    getContainerCssSelector, 
    getTargetNodeCssSelector, 
    getColumnCount,
    highlight, 
    clearStyle, 
    setLeaveStyle, 
    setEnterStyle,
    searchLinkPath,
    getPathWithClasses,  //new functionality TESTING
    getNewContainerPath,
} from 'utils/news-manager';
import { createWebFeed, getResourceById, getOriginalSite, refreshFile, getNewsPreview } from 'utils/api';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { logout } from 'redux/modules/auth/action';
import { openFeedPreviewModal } from 'redux/modules/modals/actions';
import Loader from 'components/Loader';
import Desktop from './Desktop';
import Mobile from './Mobile';
import './style.scss';
class Preview extends Component {
    state = {
        activeFilter: 'Title',
        ContainerPath: null,
        TitlePath: null,
        DescriptionPath: null,
        DatePath: null,
        LinkPath: null,
        fetchedData: null,
        usage_js: null,
        feed: null,
        url: null,
        feedName: '',
        submitting: false,
        isDragging: false,
        loaded: false,
        selectionType: '1',
    };

    static getDerivedStateFromProps(props, state) {
        // this is used for saving data after page reload
        if (props.routerBridgeProps === null && (state.url === null || state.feedName === '')) {
            return {
                url: window.localStorage.getItem('url'),
                feedName: window.localStorage.getItem('feedName'),
                path: window.localStorage.getItem('path'),
                usage_js: window.localStorage.getItem('usage_js') !== 'undefined' ? JSON.parse(window.localStorage.getItem('usage_js')) : false,
            };
        }

        return null;
    }

    componentDidMount() {
        if (this.props.match.params.id !== undefined) {
            this.editModeInitialization(this.props.match.params.id);
        } else if(this.props.routerBridgeProps) {
            const { routerBridgeProps } = this.props;
            const encodedHtmlTitle = this.decodeEntities(routerBridgeProps.title);
            
            //Saving data in localStorage to get it after page reload
            window.localStorage.setItem('url', routerBridgeProps.url);
            window.localStorage.setItem('feedName', encodedHtmlTitle);
            window.localStorage.setItem('path', routerBridgeProps.path);
            window.localStorage.setItem('usage_js', routerBridgeProps.usage_js);

            this.setState({
                url: routerBridgeProps.url,
                feedName: encodedHtmlTitle,
                path: routerBridgeProps.path,
                usage_js: routerBridgeProps.usage_js,
            });
        }
    }

    editModeInitialization = async (id) => {
        try {
            this.setState({fetchedData: false});

            const feed = await getResourceById(id, 'web_resource');

            const site = await getOriginalSite({
                path: feed.originalUrl,
                html_response: !this.isProd(),
                url_response: true,
                usage_js: false,
                is_edit: true,
            });

            !this.isProd() && await (refreshFile(site.html));

            const encodedHtmlTitle = this.decodeEntities(feed.feedName);
            
            this.setState({
                fetchedData: true,
                feedName: encodedHtmlTitle,
                usage_js: site.usage_js,
                url: site.url,
                path: feed.originalUrl,
                feed,
            });
        } catch (error) {
            console.log(error)
            if(error.message === 'Resource not found' || error.code === 'NOT_FOUND') {
                this.props.history.push('/feeds/fetches');
            }
            throw error;
        }
    };

    loadScripts = (event) => {
        event.preventDefault();
        window.localStorage.setItem('usage_js', true);

        this.resetAll();

        this.setState(
            { usage_js: true },
            async () => {
                try {
                    this.setState({ fetchedData: false });

                    const seleniumResource = await getOriginalSite({
                        url: this.state.path,
                        html_response: !this.isProd(),
                        url_response: true,
                        usage_js: true,
                    });

                    const encodedHtmlTitle = this.decodeEntities(seleniumResource.title);

                    if (!this.isProd()) {
                        await refreshFile(seleniumResource.html);
                    }
                    //need to add new url and feedName to localStorage
                    this.setState({
                        fetchedData: true,
                        url: seleniumResource.url,
                        feedName: encodedHtmlTitle,
                    });
                } catch (err) {
                    console.log(err)
                    if(err.message && err.message.length < 150) {
                        toast.error(err.message);
                    }
                }
            }
        );
    };

    decodeEntities = (str) => {
        let element = document.createElement('div');
        if(str && typeof str === 'string') {
            element.innerHTML = str;
            str = element.textContent;
            element.textContent = '';
        }
        return str;
    };

    preSelectElements = () => {
        const { feed } = this.state;
        const bodyFromIframe = this.getBodyFromIframe();

        try {
            highlight(feed.containerPath, feed.titlePath, bodyFromIframe, 'Title');

            this.setState({
                ContainerPath: feed.containerPath,
                TitlePath: feed.titlePath,
                LinkPath: feed.linkPath,
            });

            if (null !== feed.descriptionPath) {
                highlight(feed.containerPath, feed.descriptionPath, bodyFromIframe, 'Description');

                this.setState({DescriptionPath: feed.descriptionPath});
            }

            if (null !== feed.datePath) {
                highlight(feed.containerPath, feed.datePath, bodyFromIframe, 'Date');

                this.setState({DatePath: feed.datePath});
            }
        } catch (err) {
            console.log(err)
            console.log('Filters are cleaned, preSelectElements err: ', err);
        }
    };
    /**
     * @returns Element <body>...</body>
     */
    getBodyFromIframe = () => {
        const iframe = document.getElementsByTagName('iframe')[0];

        return (iframe.contentDocument || iframe.contentWindow.document).querySelector('body');
    };

    /**
     * @param actionName String
     * @param event MouseEvent
     *
     * @returns mixed
     */
    handleAction = (actionName, event) => {
        if (actionName === 'leave') {
            setLeaveStyle(event.target);
        } else if (actionName === 'enter') {
            setEnterStyle(event.target);
        } else if (actionName === 'click') {
            const { activeFilter } = this.state;

            try {
                if (activeFilter !== '') {
                    const bodyFromIframe = this.getBodyFromIframe();
                    let pathToContainer;
                    let pathToTargetNode;

                    if(this.state.selectionType === '1') {
                        let path = event.path || (event.composedPath && event.composedPath());
                        let fullPath = getPathWithClasses(event.target);
                        //pathToContainer = getNewContainerPath(event.target).replace(/ /g, ' > ');
                        pathToContainer = getNewContainerPath(event.target, bodyFromIframe, [...path], fullPath);
                        //console.log('pathToContainer: ', pathToContainer);
                        pathToTargetNode = fullPath.replace(pathToContainer + ' > ', '');
                        //console.log('pathToTargetNode: ', pathToTargetNode);
                        //console.log('element: ', bodyFromIframe.querySelectorAll(pathToContainer + ' > ' + pathToTargetNode));
                        //console.log('container: ', bodyFromIframe.querySelectorAll(pathToContainer));
                    } else if(this.state.selectionType === '2') {
                        let path = event.path || (event.composedPath && event.composedPath());
                        pathToContainer = getContainerCssSelector([...path], bodyFromIframe); //why is there [...path]?
                        pathToTargetNode = getTargetNodeCssSelector(pathToContainer, [...path]);
                    }

                    //needs to be moved lower
                    this.setState({ ContainerPath: pathToContainer });

                    const currentPath = this.state[`${activeFilter}Path`];
                    if (!currentPath && pathToTargetNode !== currentPath) {
                        highlight(pathToContainer, pathToTargetNode, bodyFromIframe, activeFilter, this.state.selectionType);
                    }

                    if (this.state.TitlePath && this.state.TitlePath === pathToTargetNode) {
                        this.deletePath('Title');
                        this.setState({activeFilter: 'Title'});
                    } else if (this.state.DescriptionPath && this.state.DescriptionPath === pathToTargetNode) {
                        this.deletePath('Description');
                        this.setState({activeFilter: 'Description'});
                    } else if (this.state.DatePath && this.state.DatePath === pathToTargetNode) {
                        this.deletePath('Date');
                        this.setState({activeFilter: 'Date'});
                    } else if (!currentPath) {
                        this.setState(
                            {
                                [`${activeFilter}Path`]: pathToTargetNode
                            },
                            () => this.getNextFilter(activeFilter)
                        );
                    }
                }
            } catch (error) {
                console.log(error)
                const msg = error.message;
                console.log(error);
                if (msg !== NOT_NEWS_MSG && msg !== CANNOT_SELECT_IMG_MSG && msg !== EMPTY_ARRAY_MSG) {
                    toast.error(msg);
                }
            }
        }
    };

    /**
     * @returns {Promise<*>}
     *
     * @throws ToastError
     */
    getPreview = async () => {
        await this.setStateLinkPath(); // remove await. setStateLinkPath is not async function

        try {
            return await getNewsPreview(this.buildResultParams());
        } catch (error) {
            console.log(error)
            let msg = 'Unable to fetch preview data for your selection';

            if (error.errors && error.errors.container_path && error.errors.container_path !== '') {
                msg = error.errors.container_path;
            } else if (!this.state.TitlePath) {
                msg = 'Need to check Title!';
            } else if (error.code === 'INTERNAL_ERROR') {
                msg = 'Backend error: '+error.message;
            } //else if (error.code === 'ACCESS_DENIED') {
                //msg = 'Access error: ' + error.message;
                //this.props.logout();
                //this.props.history.push('/sign_in');
            //}

            toast.error(msg);
        }
    };

    setStateLinkPath = () => {
        const bodyFromIframe = this.getBodyFromIframe();
        const containerPath = this.state.ContainerPath;
        let linkPath = '';

        if (this.state.TitlePath !== null) {
            linkPath = searchLinkPath(containerPath, this.state.TitlePath, bodyFromIframe);
        }
        if (linkPath === '' && this.state.DescriptionPath !== null) {
            linkPath = searchLinkPath(containerPath, this.state.DescriptionPath, bodyFromIframe);
        }
        if (linkPath === '' && this.state.DatePath !== null) {
            linkPath = searchLinkPath(containerPath, this.state.DatePath, bodyFromIframe);
        }

        // this.setState({ LinkPath: linkPath });
        if(linkPath) {
            this.setState({LinkPath: linkPath});
        }
    };

    buildResultParams = () => {
        return {
            url: this.state.path,   //not sure if feed.originalUrl is necessary
            container_path: this.state.ContainerPath,
            title_path: this.state.TitlePath,
            abstract_path: this.state.DescriptionPath,
            url_path: this.state.LinkPath && this.state.LinkPath === this.state.ContainerPath ? ':href' : this.state.LinkPath,
            date_path: this.state.DatePath,
            usage_js: this.state.usage_js,
            title: this.state.feedName,
            vs_preview: true,
            //columnCount: getColumnCount(),
            //selectionType: this.state.selectionType,
        };
    };

    /**
     * @param activeFilter String 'Title'
     */
    getNextFilter = (activeFilter) => {
        // Fix of filter picker need to refactor if possible
        if(this.state.TitlePath) {
            if(this.state.DescriptionPath){
                this.setState({
                    activeFilter: 'Date',
                });
            } else {
                this.setState({
                    activeFilter: 'Description',
                });
            }
        } else if(activeFilter === 'Description') { 
            if(this.state.DatePath) {
                this.setState({
                    activeFilter: 'Title',
                });
            } else {
                this.setState({
                    activeFilter: 'Date',
                });
            }
        } else if(activeFilter === 'Date') {
            if(this.state.TitlePath && !this.state.DescriptionPath) { 
                this.setState({
                    activeFilter: 'Description',
                });
            } else {
                this.setState({
                    activeFilter: 'Title',
                });
            }
        }
    };

    handleLoad = (event) => {
        this.addEventListenersToIframe(event);

        const allNodes = Array.from(this.getBodyFromIframe().getElementsByTagName('*'));

        for (let i = 0; i < allNodes.length; ++i) {
            if (getComputedStyle(allNodes[i]).position === 'fixed') {
                allNodes[i].style.display = 'none';
            }
        }

        if (this.state.feed) {
            this.preSelectElements();
        }

        this.setState({ loaded: true });
    };

    addEventListenersToIframe = () => {
        this.getBodyFromIframe().addEventListener('click', (event) => {
            event.preventDefault();
            this.handleAction('click', event);
        });
        this.getBodyFromIframe().addEventListener('mousemove', (event) => {
            event.preventDefault();
            event.target.addEventListener('mouseover', (event) => this.handleAction('enter', event));
            event.target.addEventListener('mouseout', (event) => this.handleAction('leave', event));
        });
    };

    handleChangeFilter = (value) => {
        this.setState({activeFilter: value});
    };

    /**
     * @param key String 'Title'|'Description'|'Date'
     */
    deletePath = (key) => {
        clearStyle(this.state.ContainerPath, this.state[`${key}Path`], this.getBodyFromIframe(), this.state.selectionType);

        this.setState({[`${key}Path`]: null});
    };

    renderFrame = () => {
        if (this.state.fetchedData || null === this.state.fetchedData) {
            return (
                <React.Fragment>
                    {!this.state.loaded && (
                        <div className="iframe-loader">
                            <Loader />
                        </div>
                    )}
                    <iframe
                        // src={this.isProd() ? this.state.url : 'parsed.html'}
                        src={this.isProd() ? this.state.url : '../../../parsed.html'}
                        title="Newsfetch visual selector"
                        onLoad={(event) => this.handleLoad(event)}
                        className={`preview-frame${!this.state.loaded ? ' unloaded': ''}${this.state.isDragging ? ' dragging' : ''}`}
                    />
                </React.Fragment>
            );
        } else {
            return (
                <div className="loader-container">
                    <div className="iframe-loader">
                        <Loader />
                    </div>
                </div>
            );
        }
    };

    onSubmit = async () => {
        if (!this.state.TitlePath) { //should be removed. If titlePath in not exist- submit button is disables
            toast.error('Need to check Title!');
        }

        try {
            await this.setStateLinkPath(); //Remove await 

            this.setState({ submitting: true });
            //Remove async await from this function. This mechanism is not used here
            //if (this.state.feed) {
            //    await updateWebFeed(this.state.feed.id, this.buildResultParams());
            //} else {
                await createWebFeed(this.buildResultParams());
            //}

            this.setState(
                { submitting: false, },
                () => { this.props.history.push('/feeds/fetches'); }
            );
        } catch (error) {
            console.log(error)
            this.setState({submitting: false});
            toast.error(error.message);
        }
    };

    resetAll = () => {
        this.state.ContainerPath && this.deletePath('Container');
        this.state.TitlePath && this.deletePath('Title');
        this.state.DescriptionPath && this.deletePath('Description');
        this.state.DatePath && this.deletePath('Date');
        this.state.LinkPath && this.deletePath('Link');

        this.handleChangeFilter('Title');
    };

    /**
     * @param feedName String
     */
    handleFeedNameChange = (feedName) => {
        this.setState({ feedName })
    };

    changeSelectionType = (type) => {
        this.resetAll();
        this.setState({ selectionType: type })
    };

    render() {
        return (
            <Fragment>
                {window.innerWidth > 888 ? (
                    <Desktop
                        TitlePath={this.state.TitlePath}
                        DescriptionPath={this.state.DescriptionPath}
                        DatePath={this.state.DatePath}
                        activeFilter={this.state.activeFilter}
                        submitting={this.state.submitting}
                        feedName={this.state.feedName}
                        loadScripts={this.loadScripts}
                        usage_js={this.state.usage_js}
                        selectionType={this.state.selectionType}
                        onSubmit={this.onSubmit}
                        deletePath={this.deletePath}
                        renderFrame={this.renderFrame}
                        onDrag={this.onDrag}
                        getPreview={this.getPreview}
                        handleChangeFilter={this.handleChangeFilter}
                        handleFeedNameChange={this.handleFeedNameChange}
                        changeSelectionType={this.changeSelectionType}
                    />
                ) : (
                    <Mobile
                        TitlePath={this.state.TitlePath}
                        DatePath={this.state.DatePath}
                        activeFilter={this.state.activeFilter}
                        DescriptionPath={this.state.DescriptionPath}
                        submitting={this.state.submitting}
                        usage_js={this.state.usage_js}
                        loadScripts={this.loadScripts}
                        getPreview={this.getPreview}
                        openFeedPreviewModal={this.props.openFeedPreviewModal}
                        onSubmit={this.onSubmit}
                        deletePath={this.deletePath}
                        renderFrame={this.renderFrame}
                        handleChangeFilter={this.handleChangeFilter}
                    />
                )}
            </Fragment>
        );
    }

    /**
     * @param isDragging Boolean
     */
    onDrag = (isDragging) => {
        this.setState({isDragging});
    };

    /**
     * @returns Boolean
     */
    isProd = () => {
        return process.env.production;
    };
}

const mapStateFromProps = ({ auth }) => ({ auth });

export default connect(mapStateFromProps, { openFeedPreviewModal, logout })(Preview);
